/**
 * "Onsite · Port Harcourt, Rivers, Nigeria" / "Remote · West Africa" /
 * "Remote · Worldwide" from a job row's work_mode / remote_scope / job_*
 * columns. Empty for jobs posted before location matching, so callers fall
 * back to the legacy companyLocation / jobLocation1 label.
 * Mirrors clientApp/src/components/JobLocation/jobLocation.ts describeJobLocation.
 */
const MODE_LABELS = { onsite: 'Onsite', hybrid: 'Hybrid', remote: 'Remote', field: 'Field / Mobile', rotational: 'Rotational' };

export const describeJobLocation = (job) => {
  if (!job?.work_mode) return '';
  const mode = MODE_LABELS[job.work_mode] ?? job.work_mode;
  if (job.work_mode !== 'remote') {
    return [mode, [job.job_city, job.job_state, job.job_country].filter(Boolean).join(', ')].filter(Boolean).join(' · ');
  }
  const where =
    job.remote_scope === 'country' ? job.job_country || job.job_country_code
    : job.remote_scope === 'continent' ? job.job_continent
    : job.remote_scope === 'region' ? job.job_region
    : job.remote_scope === 'global' ? 'Worldwide'
    : '';
  return [mode, where].filter(Boolean).join(' · ');
};

/** Location cell for job tables: the real job location, else the legacy label. */
export const jobLocationLabel = (job) => describeJobLocation(job) || job?.companyLocation || job?.jobLocation1 || '';
